import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import {
  submitOcrJobFeedback,
  type FeedbackPayload,
} from "../api/insuranceVerificationApi";
import { insuranceVerificationKeys } from "../api/insuranceVerificationKeys";

interface UseSubmitAccuracyFeedbackOptions {
  documentId: number;
  ocrJobId: number;
}

export const useSubmitAccuracyFeedback = ({
  ocrJobId,
  documentId,
}: UseSubmitAccuracyFeedbackOptions) => {
  const companyId = useCurrentCompanyId() as number;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: FeedbackPayload) =>
      submitOcrJobFeedback(companyId, ocrJobId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.ocrJob(companyId, ocrJobId),
      });
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.document(companyId, documentId),
      });
    },
  });
};
